import { Article, LifeMetric, Project, SiteControls, SocialChannel, AboutData } from '../types/content';

import projectsData from './projects.json';
import blogsData from './blogs.json';
import socialData from './social.json';
import telemetryData from './telemetry.json';
import aboutData from './about.json';

/**
 * Local fallback data — rendered instantly and used whenever api.shvms.in
 * is unreachable or a table doesn't exist yet (stale-while-revalidate).
 *
 * Each domain has its own structured JSON file with fixed schema:
 * - projects.json -> seedProjects
 * - blogs.json -> seedArticles
 * - social.json -> seedSocialChannels
 * - telemetry.json -> seedLifeMetrics
 * - about.json -> seedAboutData
 */

export const seedProjects: Project[] = projectsData as Project[];
export const seedArticles: Article[] = blogsData as Article[];
export const seedSocialChannels: SocialChannel[] = socialData as SocialChannel[];
export const seedLifeMetrics: LifeMetric[] = telemetryData as LifeMetric[];
export const seedAboutData: AboutData = aboutData as AboutData;

export const defaultSiteControls: SiteControls = (aboutData as AboutData).controls || {
  show_location: true,
  location_label: 'India',
  show_life_pulse: true,
  show_visitor_count: true,
};
